// useSubtasksById.ts
import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const fetchSubtasksByParentSK = async (parentTaskSK: string) => {
  const { data } = await axios.get(`${baseUrl}/aws/tasks/query-subtasks`, {
    params: { parentSK: parentTaskSK },
  })
  return data || []
}

export const useSubtasksByTaskId = (parentTaskSK: string, enabled = true) => {
  return useQuery({
    queryKey: ['subtasks', parentTaskSK],
    queryFn: () => fetchSubtasksByParentSK(parentTaskSK),
    enabled: !!parentTaskSK && enabled,
    staleTime: 1000 * 60 * 5,
  })
}
